export class ApiV4Error extends Error {
  public status: number;
  public errorCode: string;
  public errorMessage: string;
  public errorDetails: string[];
  constructor(params: { status: number; error_code: string; error_message: string; error_details: string[] }) {
    super(params.error_message);
    this.name = 'ApiV4Error';
    Object.setPrototypeOf(this, new.target.prototype);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiV4Error);
    }
    this.status = params.status;
    this.errorCode = params.error_code;
    this.errorMessage = params.error_message;
    this.errorDetails = params.error_details;
  }
}
